import { createExternalResourceSelectors } from '@next/arable-lib/external-resource';

import { selectSoilTypeState } from './soil-type.feature';

export const SoilTypeSelectors = createExternalResourceSelectors(selectSoilTypeState, (state) => state.soilTypes);
